import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

// Shown when the user leaves the table settings view with edits that the batched save has not
// written yet. Saving can be rejected by ingestion rule validation, so the parent decides whether
// the departure actually happens.
function UnsavedSettingsDialog({ open, saving, onSaveAndContinue, onDiscard, onStay }) {
  return (
    <Dialog open={open} onClose={onStay} aria-labelledby="unsaved-settings-dialog-title">
      <DialogTitle id="unsaved-settings-dialog-title">Unsaved changes</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have unsaved changes to this table's settings. Do you wish to save them before leaving?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onStay} disabled={saving}>
          Stay
        </Button>
        <Button onClick={onDiscard} color="error" disabled={saving}>
          Discard changes
        </Button>
        <Button onClick={onSaveAndContinue} variant="contained" disabled={saving}>
          {saving ? 'Saving...' : 'Save and continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedSettingsDialog;
